<div class="deusto-logo">
    <img id="adf-login-img-logo" class="adf-img-logo ng-star-inserted" alt="Deusto logo"
        src="assets/deusto-extension/images/LogoDeustoBlanco.png">
</div>

<div class="udeu-home-content"
    [style.background-image]="'linear-gradient(' + linearGradient + '), url(' + backgroundImageUrl + ')'">
    <div class="spinner-center loading adf-login-card-wide" *ngIf="loading">
        <span class="mb20">Configurando el perfil...</span>
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!loading" class="modules">
        <mat-card *ngIf="canBoud" appearance="outlined" class="adf-login-card-wide" (click)="navigateTo('viewer/boud')">
            <mat-card-content>
                <mat-icon fontSet="material-icons-outlined">menu_book</mat-icon>
            </mat-card-content>
            <mat-card-header class="adf-login-card-header-text">
                <mat-card-title>
                    {{'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.TITLE' | translate }}
                </mat-card-title>
            </mat-card-header>
        </mat-card>

        <mat-card *ngIf="canLoans" appearance="outlined" class="adf-login-card-wide"
            (click)="navigateTo('viewer/loans')">
            <mat-card-content>
                <mat-icon>folder_shared</mat-icon>
            </mat-card-content>
            <mat-card-header class="adf-login-card-header-text">
                <mat-card-title>
                    {{'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.TITLE' | translate }}
                </mat-card-title>
            </mat-card-header>
        </mat-card>

        <mat-card *ngIf="canTransferCalendar" appearance="outlined" class="adf-login-card-wide"
            (click)="navigateTo('viewer/transfer-calendar')">
            <mat-card-content>
                <mat-icon>today</mat-icon>
            </mat-card-content>
            <mat-card-header class="adf-login-card-header-text">
                <mat-card-title>
                    {{'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.TITLE_CALENDAR' | translate }}
                </mat-card-title>
            </mat-card-header>
        </mat-card>

        <mat-card *ngIf="canTransfers" appearance="outlined" class="adf-login-card-wide"
            (click)="navigateTo('viewer/transfers')">
            <mat-card-content>
                <mat-icon>present_to_all</mat-icon>
            </mat-card-content>
            <mat-card-header class="adf-login-card-header-text">
                <mat-card-title>
                    {{'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.TITLE' | translate }}
                </mat-card-title>
            </mat-card-header>
        </mat-card>

        <mat-card *ngIf="canRecords" appearance="outlined" class="adf-login-card-wide"
            (click)="navigateTo('viewer/records')">
            <mat-card-content>
                <mat-icon>dvr</mat-icon>
            </mat-card-content>
            <mat-card-header class="adf-login-card-header-text">
                <mat-card-title>
                    {{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.TITLE' | translate }}
                </mat-card-title>
            </mat-card-header>
        </mat-card>

        <mat-card *ngIf="canAdministration" appearance="outlined" class="adf-login-card-wide"
            (click)="navigateTo('viewer/administration')">
            <mat-card-content>
                <mat-icon>settings</mat-icon>
            </mat-card-content>
            <mat-card-header class="adf-login-card-header-text">
                <mat-card-title>
                    {{'DEUSTO.NEW_MENU.MENU_ITEMS.ADMINISTRATION.TITLE' | translate }}
                </mat-card-title>
            </mat-card-header>
        </mat-card>

        <mat-card *ngIf="!(canLoans || canTransfers || canRecords || canAdministration || canBoud)"
            appearance="outlined" class="adf-login-card-wide" (click)="navigateTo('personal-files')">
            <mat-card-content>
                <mat-icon role="img"
                    class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color ng-star-inserted"
                    aria-hidden="true" data-mat-icon-type="font">folder</mat-icon>
            </mat-card-content>
            <mat-card-header class="adf-login-card-header-text">
                <mat-card-title>
                    {{'APP.BROWSE.PERSONAL.SIDENAV_LINK.LABEL' | translate }}
                </mat-card-title>
            </mat-card-header>
        </mat-card>
    </div>
</div>